export class ValorEntregado {
    constructor({ tipoFrmEmpresa }) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;

        this.model = {
            detalle_act_economica: {
                value: '',
                header: 'Los valores entregados y los que se entregarán, provienen de la siguiente actividad económica o fuente:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Los valores entregados y los que se entregarán, provienen de la siguiente actividad económica o fuente:',
                },
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4,
                required: 'Los valores entregados provienen es requerido',
            },
            tipo_valor_entregado: {
                value: null,
                header: 'Los valores entregados son:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Los valores entregados o por entregar son:',
                    FRM_DIFARE: 'Los valores entregados o por entregar son:',
                },
                required: 'Tipo de valor es requerido.'
            },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
    strBeneDeclara = `Declaro el origen lícito de mis recursos por cuanto los valores entregados son generados de mis actividades económicas legales y no provienen del lavado de activos,
        financiamiento del terrorismo y otros delitos.`;
    strBeneficiario = <><b>Definición de Beneficiario final: </b>es toda persona natural que finalmente posee o controla a un cliente y/o la persona natural en cuyo nombre se
        realiza la transacción. Incluye también a las personas naturales que ejercen el control efectivo final sobre una persona jurídica u otra estructura jurídica</>
}
